import React, { useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { connect, useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import CreatableSelect from "react-select/creatable";

const TripSessionDetail = () => {
    const [imei, setImei] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [tripData, setTripData] = useState(null);
    const [selectedImei, setSelectedImei] = useState(null);
    const [imeiOptions, setImeiOptions] = useState([
        { value: '352592572010858', label: '352592572010858 - Honda City' },
        { value: '353691841172736', label: '353691841172736 - Not Mapped' },
        { value: '353691841180044', label: '353691841180044 - Ofc Genset' },
    ]);

    const access_token = useSelector(state => state.auth.access_token);

    const selectTapHandle = (selectedOption, fieldName) => {
        if (fieldName === 'imei') {
            setSelectedImei(selectedOption);
            if (selectedOption) {
                setImei(selectedOption.value);
            } else {
                setImei('');
            }
        }
    };

    const handleImeiCreate = (inputText) => {
        const newOption = {
            value: inputText,
            label: `${inputText} `
        };
        
        setImeiOptions(prev => [...prev, newOption]);
        
        setSelectedImei(newOption);
        setImei(inputText);
        
    };

    const fetchTripData = (imei, startDate, endDate) => {
        setLoading(true);
        setTripData(null);

        const requestBody = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization('POST', `http://tappetbox.mysolutions.in/api/Report/trip-session?closeOpenAtEnd=false`, access_token, {}, requestBody, (resp) => {
            setTripData(resp.data);
            toast.success('Trip data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to trip device data', { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedImei) {
            toast.error('Please select an IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        fetchTripData(imei, startDate, endDate);
    };

    const formatValue = (key, value) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }

        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return new Date(value).toLocaleString();
        }

        return value.toString();
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

    const renderTripData = () => {
        if (!tripData) return null;

        if (Array.isArray(tripData) && tripData.length === 0) {
            return (
                <div className="row mt-4">
                    <div className="col-12">
                        <h6>No trip data available.</h6>
                    </div>
                </div>
            );
        }

        const trips = Array.isArray(tripData) ? tripData : [tripData];

        return (
            <div className="row mt-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center ">
                        <h5>Trip Session Details</h5>
                    </div>

                    <div className="mb-3 p-3 bg-light rounded">
                        <strong className='me-5'>IMEI Number: </strong>
                        {trips[0]?.imei || 'N/A'}
                    </div>

                    {trips.map((trip, tripIndex) => (
                        <div key={tripIndex} className=" mb-4">
                            <div className="tab_content_wrapper">
                                <h6 className="mb-0">Trip {tripIndex + 1}</h6>
                            </div>
                            <div className="card-body p-0 mt-3">
                                <table className="table table-bordered mb-0 table-hover">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: "20%" }}>Parameter</th>
                                            <th style={{ width: "20%" }}>Start</th>
                                            <th style={{ width: "20%" }}>Stop</th>
                                            <th style={{ width: "20%" }}>Total Duration</th>
                                            <th style={{ width: "20%" }}>Total KM Running</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="fw-bold">CL</td>
                                            <td>{trip?.startCL || 'N/A'}</td>
                                            <td>{trip?.closeCL || 'N/A'}</td>
                                            <td rowSpan="5" className="align-middle text-center">
                                                <strong>{trip?.totalDuration || 'N/A'}</strong>
                                            </td>
                                            <td rowSpan="5" className="align-middle text-center">
                                                <strong>{trip?.totalKmRunning ? `${trip.totalKmRunning} km` : 'N/A'}</strong>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="fw-bold">Latitude, Longitude</td>
                                            <td>
                                                {trip?.startLat || 'N/A'}, {trip?.startLong || 'N/A'}
                                                
                                            </td>
                                            <td>
                                                {trip?.stopLat || 'N/A'}, {trip?.stopLong || 'N/A'}
                                                
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="fw-bold">Location</td>
                                            <td>
                                                {trip?.startLocation ? (
                                                    <a 
                                                        href={trip.startLocation} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer" 
                                                    >
                                                        View Start Map
                                                    </a>
                                                ) : 'N/A'}
                                            </td>
                                            <td>
                                                {trip?.stopLocation ? (
                                                    <a 
                                                        href={trip.stopLocation} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer" 
                                                    >
                                                        View Stop Map
                                                    </a>
                                                ) : 'N/A'}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="fw-bold">Timestamp</td>
                                            <td>
                                                {trip?.startTimestamp ?
                                                    new Date(trip.startTimestamp).toLocaleString() : 'N/A'
                                                }
                                            </td>
                                            <td>
                                                {trip?.stopTimestamp ?
                                                    new Date(trip.stopTimestamp).toLocaleString() : 'N/A'
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const handleDateTimeChange = (field, value) => {
        if (field === 'startDate') {
            setStartDate(value);
        } else if (field === 'endDate') {
            setEndDate(value);
        }
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Trip Data</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>Latest Trip Data</h3>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="imei" className="form-label require">IMEI</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <CreatableSelect
                                            required={true}
                                            value={selectedImei}
                                            options={imeiOptions}
                                            onChange={(selectedOption) => selectTapHandle(selectedOption, 'imei')}
                                            onCreateOption={handleImeiCreate}
                                            isClearable={true}
                                            isMulti={false} 
                                            placeholder="Please Select IMEI Number"
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: '#dee2e6',
                                                    minHeight: '38px'
                                                })
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="startDate" className="form-label require">Start Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(value) => handleDateTimeChange('startDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Start Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="endDate" className="form-label require">End Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(value) => handleDateTimeChange('endDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter End Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-7"></div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            disabled={loading || !selectedImei}
                                            className="btn btn-primary "
                                        >
                                            GO
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {loading && <Loader />}
                            {renderTripData()}
                        </div>
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default TripSessionDetail;